import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { useFieldMeta, useIsUnverified } from '@/hooks/useDataPointMeta';

/**
 * Diskret badge der markerer et tal som endnu ikke verificeret af redaktionen.
 * Vises kun når feltet har et registreret datapunkt uden verifikationsdato.
 */
export function UnverifiedBadge({ field }: { field?: string }) {
  const unverified = useIsUnverified(field);
  const meta = useFieldMeta(field);

  if (!unverified) return null;

  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            className="ml-1.5 inline-flex shrink-0 items-center rounded border border-accent/40 bg-accent/10 px-1.5 py-px align-middle text-[9px] font-bold uppercase leading-[14px] tracking-wide text-accent"
            aria-label="Ubekræftet oplysning"
          >
            Ubekræftet
          </span>
        </TooltipTrigger>
        <TooltipContent className="max-w-[16rem] text-xs">
          Tallet er indlæst fra {meta?.sourceLabel ?? 'en ekstern kilde'} og afventer redaktionel kontrol.
          {meta?.isEstimated ? ' Værdien er angivet som et estimat.' : ''}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
